<app-banner></app-banner>

<section class="main-section white-bg">
    <div class="width-container">
        <h2 id="ended-header" tabindex="-1" class="no-outline" [innerHtml]="'ERROR.PROMOTION_ENDED.HEAD' | translate"></h2>
        <p [innerHtml]="'ERROR.PROMOTION_ENDED.DESC' | translate"></p>
        <a [href]="'ERROR.PROMOTION_ENDED.VIEW_OTHER_LINK' | translate" target="_blank" [attr.aria-label]="('ERROR.PROMOTION_ENDED.VIEW_OTHER_BTN' | translate) + ', opens in a new tab'"><button class="btn" tabindex="-1" [innerHtml]="'ERROR.PROMOTION_ENDED.VIEW_OTHER_BTN' | translate"></button></a>
    </div>
</section>